import { useCallback, useContext } from "react"
import { PlayerDispatchContext } from "@/modules/player/providers/PlayerDispatchContext"
import { PlayerReducerActions, PlayerReducerState } from "@/modules/player/providers/PlayerProvider.types";

export const usePlayerPlayContext = () => {
  const dispatch = useContext(PlayerDispatchContext);

  const setPlayContext = useCallback(
    (context: PlayerReducerState["playContext"]) => {
      dispatch({
        type: PlayerReducerActions.SET_PLAY_CONTEXT,
        payload: { playContext: context },
      });
    }, [dispatch]
  )

  return { setPlayContext }
}